
import Vue from 'vue'
import CommonSearchBar from '../common/CommonSearchBar.vue'
import CommunitySubMenu from './CommunitySubMenu.vue'
import AuthHeader from './auth/AuthHeader.vue'

export default Vue.extend({
  name: 'HeaderNavBar',
  components: {
    CommunitySubMenu,
    AuthHeader,
    CommonSearchBar,
  },
  data() {
    return {
      visibleId: undefined as number | undefined,
      isSearchBarToggled: false,
      searchTerm: '',
      searchPlaceholder: this.$t('searchSomething', {
        target: 'Machinations',
      }) as string,
      shouldSearchOverlap: false,
      isHeaderSearchBarVisible: true,
    }
  },
  computed: {
    commonMenu() {
      return this.$store.state.common.menu
    },
    formSubmitError() {
      return this.$store.state.common.formSubmitError
    },
    showHeaderSearchbar() {
      this.checkSearchBarsVisibility()

      return this.isHeaderSearchBarVisible
    },
  },
  mounted() {
    this.observeContentSearchBar(
      '#content-search-bar',
      this.checkSearchBarsVisibility
    )

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.checkSearchBarsVisibility)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.checkSearchBarsVisibility)
  },
  methods: {
    observeContentSearchBar(selector, callback) {
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector)
        if (element) {
          callback()
          observer.disconnect()
        }
      })

      observer.observe(document.body, { childList: true, subtree: true })
    },
    burgerMenuPressed() {
      this.$emit('burgerPressed')
    },
    showSubMenu(id) {
      this.visibleId = id
    },
    updateSearchWidth() {
      this.$nextTick(() => {})
      const searchBarWidth = (
        window.document.querySelector('#header-search-bar') as HTMLElement
      )?.clientWidth
      const menuWidth = (this.$refs.menu as HTMLElement)?.clientWidth

      this.shouldSearchOverlap = searchBarWidth < 256 || menuWidth === 0
    },
    handleWindowResize() {
      const logoWidth = (this.$refs.logo as HTMLElement)?.clientWidth
      const menuWidth = (this.$refs.menu as HTMLElement)?.clientWidth
      const authMenuWidth = (this.$refs.authMenu as HTMLElement)?.clientWidth

      const equalizer = this.$refs.equalizer as HTMLElement
      const searchBar = this.$refs.searchBar as HTMLElement

      equalizer.style.width = `${
        (window.innerWidth - menuWidth) / 2 - logoWidth
      }px`
      searchBar &&
        (searchBar.style.width = `${
          (window.innerWidth - menuWidth) / 2 - authMenuWidth
        }px`)

      this.updateSearchWidth()
    },
    logoPressed() {
      this.$router.push('/')
    },
    menuHasChildren(menuItem) {
      return (
        (menuItem && menuItem?.children?.length) ||
        menuItem?.name === 'Community'
      )
    },
    checkSearchBarsVisibility() {
      this.$nextTick(() => {
        if (typeof window === 'undefined') {
          return false
        }

        const input = window.document.querySelector(
          '#content-search-bar' // this ID should be applied to all search bars inside the page content
        ) as HTMLInputElement

        this.isHeaderSearchBarVisible =
          !input || input.getBoundingClientRect().bottom < 80

        if (input && this.isHeaderSearchBarVisible) {
          this.searchTerm = input.value

          if (this.searchTerm) {
            this.isSearchBarToggled = !!this.searchTerm
          }
        } else {
          this.isSearchBarToggled = false
        }

        this.updateSearchWidth()
      })
    },
    toggleSearchBar(value: boolean) {
      this.isSearchBarToggled = value

      if (this.isSearchBarToggled) {
        this.updateSearchWidth()
      }
    },
    isActiveRoute(currentPageSlug, menuItem) {
      if (!currentPageSlug || !menuItem) return false

      const cleanCurrentSlug =
        currentPageSlug.replace(/^\/|\/$/g, '').split('/')[0] || ''
      const itemSlug = menuItem.slug?.replace(/^\/|\/$/g, '') || ''
      if (cleanCurrentSlug === itemSlug) {
        return true
      }

      const checkNestedChildren = (children) => {
        if (!children) return false

        return children.some((child) => {
          const childSlug = child.slug?.replace(/^\/|\/$/g, '') || ''
          if (cleanCurrentSlug === childSlug) {
            return true
          }

          if (child.children?.length) {
            return checkNestedChildren(child.children)
          }

          return false
        })
      }

      return checkNestedChildren(menuItem.children)
    },
  },
})
